import { useAtticLocationListQuery } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import usePaginator, {
  createPaginationState,
  PaginatorContext,
} from "@dashboard/hooks/usePaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";

import AtticLocationListPage from "../components/AtticLocationListPage/AtticLocationListPage";
import {
  atticLocationListUrl,
  type AtticLocationListUrlFilters,
  type AtticLocationListUrlQueryParams,
  parseAtticLocationKind,
} from "../urls";

export const PAGINATE_BY = 50;

export const AtticLocationListView = ({ params }: { params: AtticLocationListUrlQueryParams }) => {
  const navigate = useNavigator();
  const paginationState = createPaginationState(PAGINATE_BY, params);
  const kind = parseAtticLocationKind(params.kind);
  const { data, loading, error } = useAtticLocationListQuery({
    displayLoader: true,
    variables: {
      ...paginationState,
      ...(params.parent !== undefined ? { parent: params.parent } : {}),
      ...(kind ? { kind } : {}),
      ...(params.query ? { search: params.query } : {}),
    },
  });
  const paginationValues = usePaginator({
    pageInfo: data?.atticLocations?.pageInfo,
    paginationState,
    queryString: params,
  });
  const changeFilters = (changes: Partial<AtticLocationListUrlFilters>) =>
    navigate(atticLocationListUrl({ ...params, ...changes, after: undefined, before: undefined }));

  return (
    <PaginatorContext.Provider value={paginationValues}>
      <AtticLocationListPage
        locations={loading && !data ? undefined : (mapEdgesToItems(data?.atticLocations) ?? [])}
        loadFailed={!data && !loading && !!error}
        filters={params}
        onFiltersChange={changeFilters}
      />
    </PaginatorContext.Provider>
  );
};

export default AtticLocationListView;
